module.exports = {"data":{"site":{"siteMetadata":{"title":"Glaskunst Seidelmann","description":"Glaskunst Seidelmann - mundgeblasene Glaskunst, aus eigener Herstellung bzw. handbemalt und jedes St&uuml;ck ein Unikat. Hier finden Sie eine kleine Auswahl unseres Produktspektrums."}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 376
// module chunks = 142629428675168